import lozad from "lozad";

// One shared observer for the whole page. `.observe()` is idempotent, so
// it's safe to call again whenever a new lazy image mounts.
let observerInstance: ReturnType<typeof lozad> | null = null;

export function observeLozad(): void {
    if (typeof window === "undefined") return;

    if (!observerInstance) {
        observerInstance = lozad(".lozad", { rootMargin: "200px 0px" });
    }

    observerInstance.observe();
}
